import React, { useState, useEffect, useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import ItemSpecial from '../ItemSpecial';
import { Title, Text, Root, RowRoot, Row, Icon, FinalRow, Message, BlankPage, Image, Pages, Column, ListOfItems, PageButton } from './styles';
import _ from "lodash";
import Loader from 'components/Loader';
import image from 'common/images/empty-search.png';
import { RootState } from 'store/types';
import { COLUMN_WIDTH, DEFAULT_PAGE_SIZE } from '../constants'
import { ReactComponent as NextPage } from 'common/images/icon-next-page.svg'
import { ReactComponent as PreviousPage } from 'common/images/icon-previous-page.svg'
import { ReactComponent as NextPageDisabled } from 'common/images/icon-next-page-disabled.svg'
import { ReactComponent as PreviousPageDisabled } from 'common/images/icon-previous-page-disabled.svg'
import { GetOfferInsightsAPI, OfferInsightsNextPage, OfferInsightsPrevPage } from 'features/Dealers/Performance/state/actions'
import { SIZE } from 'common/sizes';
export interface IProps {
    filters: any;
    activeFilter: boolean;
    orderBy: string;
}

const List: React.FC<IProps> = ({ filters, activeFilter, orderBy }) => {
    const dispatch = useDispatch();
    const [showLoading, setShowLoading] = useState(false)
    const rootProps = useSelector((rootState: RootState) => {
        return {
            specials: rootState.dealers.offerInsights.specials,
            offset: rootState.dealers.offerInsights.offset,
            filters: rootState.dealers.offerInsights.filters,
            search: rootState.dealers.offerInsights.search,
            stats: rootState.dealers.offerInsights.stats,
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            dateRange: rootState.dealers.offerInsights.datesRange
        }
    }, shallowEqual);

    React.useEffect(() => {
        setShowLoading(true);
        if (rootProps.stats && rootProps.selectedDealer) {
            dispatch(GetOfferInsightsAPI(rootProps.selectedDealer.id, rootProps.search, "c.lastActivityDateTime DESC", rootProps.filters, rootProps.offset, DEFAULT_PAGE_SIZE, rootProps.dateRange));
        }
    }, [rootProps.offset, rootProps.filters, rootProps.search, rootProps.selectedDealer, rootProps.stats]);

    //let rows;

    const rows = React.useMemo(() => {
        setShowLoading(false);
        if (rootProps.specials) {
            return rootProps.specials.details.map((item: any, idx: any) => <ItemSpecial key={idx} idx={idx} item={item} />)
        }
        //return  rows ;
    }, [rootProps.specials]);

    React.useEffect(() => {
        setShowLoading(true);
    }, [rootProps.offset, rootProps.filters, rootProps.search]);


    return (
        <Root id="scrollableDiv">
            <RowRoot>
                <Row>
                    <Column style={{ flex: COLUMN_WIDTH['Special'] }}>
                        {`Special`}
                    </Column>
                    <Column style={{ flex: COLUMN_WIDTH['Activity'] }}>
                        Activity
                    </Column>
                    <Column style={{ flex: COLUMN_WIDTH['Listings'], textAlign: 'center' }}>
                        Listings
                    </Column>
                    <Column style={{ flex: COLUMN_WIDTH['Date and Time'], minWidth: `${SIZE.TWENTYSIX}px` }}>
                        Date and Time
                    </Column>
                    <Column style={{ flex: COLUMN_WIDTH['Views'] }}>
                        Views
                    </Column>
                    <Column style={{ flex: COLUMN_WIDTH['Engagement'] }}>
                        Engagement
                    </Column>
                </Row>
            </RowRoot>

            {
                renderRows(rows)
            }
                    <RowRoot>            
                        <FinalRow> 
                            <Pages>
                                 {rootProps.specials && rootProps.specials.details.length>0 && `${rootProps.offset + 1}-${(rootProps.offset + DEFAULT_PAGE_SIZE) > (rootProps.specials ? rootProps.specials?.totalItems : 0) ? (rootProps.specials?.totalItems) : (rootProps.offset + DEFAULT_PAGE_SIZE)} of ${rootProps.specials?.totalItems}`}
                            </Pages>

                            <Icon>
                                {rootProps.offset == 0 ? <PreviousPageDisabled /> : <PreviousPage onClick={() => { dispatch(OfferInsightsPrevPage()) }} style={{cursor:'pointer'}} />}
                            </Icon>
                            <Icon>
                                {(rootProps.offset + DEFAULT_PAGE_SIZE) >= (rootProps.specials ? rootProps.specials?.totalItems : 0) ? <NextPageDisabled /> : <NextPage onClick={() => { dispatch(OfferInsightsNextPage()) }} style={{cursor:'pointer'}} />}
                            </Icon>
                        </FinalRow>
                    </RowRoot>            
        </Root >
    );


    function renderRows(rows) {
        if (rows && rows.length === 0) {
            return (
                <BlankPage>
                    <Image>
                        <img src={image} />
                    </Image>
                    <Message>
                        Oops, we couldn't find what you were searching for.
                    </Message>
                    <Message>
                        Try again with other words or filters.
                    </Message>
                </BlankPage>
            )
        } else if (!showLoading) {
            return (
                <ListOfItems>
                    {rows}

                </ListOfItems>
            )
        }
        else {
            return (
                <Loader />
            )
        }
    }
}

export default List;